<template>
  <div>
    <div ref="tableOne" id="tableOne" style="margin-top: 15px"></div>
    <div ref="tableTwo" id="tableTwo" style="margin-top: 15px"></div>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
export default {
  props: {
    tableOne: {
      columns: Array,
      data: Array,
    },
    tableTwo: {
      columns: Array,
      data: Array,
    },
    fileName: String,
  },
  data() {
    return {
      tabulatorOne: null,
      tabulatorTwo: null,
    };
  },
  methods: {
    tabulatorDownload() {
      var sheets = {
        "Fund Performance": "#tableOne",
        "Top 5 performing companies": true,
      };
      this.tabulatorTwo.download("xlsx", this.fileName, { sheets: sheets });
      setTimeout(() => {
        var xlsScript = document.createElement("script");
        xlsScript.setAttribute("src", "static/js/xlsx.full.min.js");
        xlsScript.setAttribute("id", "xlsScript");
        document.head.appendChild(xlsScript);
      }, 1000);
    },
  },
  mounted() {
    let self = this;
    self.tabulatorOne = new Tabulator(self.$refs.tableOne, {
      layout: "fitDataFill",
      index: "id",
      virtualDom: false,
      height: "100%",
      data: self.tableOne.data ? self.tableOne.data : [],
      columns: self.tableOne.columns ? self.tableOne.columns : [],
    });
    self.tabulatorTwo = new Tabulator(self.$refs.tableTwo, {
      layout: "fitDataFill",
      index: "id",
      virtualDom: false,
      height: "100%",
      data: self.tableTwo.data ? self.tableTwo.data : [],
      columns: self.tableTwo.columns ? self.tableTwo.columns : [],
      downloadComplete: function () {
        self.$parent.showDownloadTables = false;
      },
    });
    setTimeout(() => {
      self.tabulatorDownload();
    }, 1500);
  },
};
</script>
<style>
</style>